import React, { useEffect, useState } from "react";
import { getMarket } from "../lib/api";
import { useCurrency } from "../lib/currency";

export const TickerBar = () => {
    const [items, setItems] = useState([]);
    const { format } = useCurrency();

    useEffect(() => {
        let mounted = true;
        const load = async () => {
            try {
                const [stocks, crypto, comm] = await Promise.all([
                    getMarket("indices"),
                    getMarket("crypto"),
                    getMarket("commodities"),
                ]);
                if (mounted) setItems([...stocks, ...crypto, ...comm]);
            } catch (e) {
                if (process.env.NODE_ENV !== "production") {
                    console.error("ticker load", e);
                }
            }
        };
        load();
        const id = setInterval(load, 90000);
        return () => { mounted = false; clearInterval(id); };
    }, []);

    if (!items.length) {
        return (
            <div className="border-b border-soft bg-elev h-9 flex items-center px-4">
                <span className="text-mute text-xs">Caricamento ticker…</span>
            </div>
        );
    }

    const doubled = [...items, ...items];

    return (
        <div data-testid="ticker-bar" className="border-b border-soft bg-elev overflow-hidden h-9 relative">
            <div className="ticker-track flex items-center h-full whitespace-nowrap">
                {doubled.map((it, i) => {
                    const up = (it.change_pct || 0) >= 0;
                    return (
                        <div key={`${it.symbol}-${i}`} className="flex items-center gap-2 px-5 text-xs">
                            <span className="text-amber font-semibold">{it.symbol}</span>
                            <span className="tnum text-dim">{format(it.price, { decimals: 4 })}</span>
                            <span className={`tnum ${up ? "text-green-up" : "text-red-down"}`}>
                                {up ? "▲" : "▼"} {Math.abs(it.change_pct || 0).toFixed(2)}%
                            </span>
                            <span className="text-mute">|</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
